<template>
    <div id="page">
        <task-rate-modal v-if="showTaskrateModal" @close="showTaskrateModal = false" :taskId="selectedTaskId" :taskFolderId="selectedTaskFolderId"></task-rate-modal>
        <task-reference v-if="showTaskRefModal" @close="showTaskRefModal = false" :taskId="selectedTaskId" :taskFolderId="selectedTaskFolderId"></task-reference>
        <task-close-confirm v-if="showTaskCloseModal" @close="showTaskCloseModal = false" @sendCloseTaskFolder="sendCloseTaskFolder" :taskId="selectedTaskId" :taskFolderId="selectedTaskFolderId"></task-close-confirm>

        <div class="page-content">
            <div class="page-title page-title-small">

                <h2 class="page-title-h2"><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>لیست {{lableText('TasksName')??'وظایف'}} من<button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button></h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="" data-card-height="150" style="-webkit-transform: translate3d(0, 0, 0); background-size: cover; border: 0px !important; max-height: 150000px; margin-bottom: 30px; background-position: center center !important; z-index: -1; top: 0px; position: absolute; left: -8px; right: -8px; overflow: hidden; border-bottom-left-radius: 45px; border-bottom-right-radius: 45px;">
                <div style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1; opacity: 0.95; background-color: #4a89dc !important;"></div>
                <div class="dark-mode-tint" style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1;"></div>
                <div style="background-image: url(/assets/Images/pictures/20.jpg); background-position: center center; background-repeat: no-repeat; position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; background-size: cover; z-index: 0;"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div v-if="isFreeRegist!==true">
                <div class="card card-style mb-2 z-index10000">
                    <div class="d-flex justify-content-start p-3">
                        <button id="filterBtn" type="button" class="btn btn-xs rounded-m bg-magenta2-dark ml-1" data-toggle="modal" data-target="#searchModal">
                            <i class="fa fa-filter"></i>
                        </button>
                        <div class="btn-group btn-group-sm" role="group" aria-label="Button group with nested dropdown">
                            <button class="btn btn-xs rounded-r-m bg-magenta2-light" @click="sortByDesc=!sortByDesc; refreshTaskList()"><i :class="{'fa fa-sort-amount-up': !sortByDesc,  'fa fa-sort-amount-down': sortByDesc}"></i></button>

                            <div class="btn-group btn-group-lg" role="group" aria-label="Button group with nested dropdown">
                                <button id="dropdownMenuButton" type="button" class="btn btn-xs rounded-l-m bg-magenta2-light dropdown-toggle ml-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                </button>
                                <div class="dropdown-menu z-index10000" id="dropdownMenuSortDiv" aria-labelledby="dropdownMenuButton">
                                    <a href="#" :class="{'bg-magenta1-light': sortBy=='l.TaskDate'}" class="dropdown-item" @click.prevent="sortList('l.TaskDate')">{{lableText('TaskDate')??'تاریخ وظیفه'}} </a>
                                    <a href="#" :class="{'bg-magenta1-light': sortBy=='f.EndDateTime'}" class="dropdown-item" @click.prevent="sortList('f.EndDateTime')">{{lableText('EndDateTime')??'زمان پایان'}} </a>
                                    <a href="#" :class="{'bg-magenta1-light': sortBy=='f.CreateDateTime'}" class="dropdown-item" @click.prevent="sortList('f.CreateDateTime')">زمان ثبت </a>
                                    <a href="#" :class="{'bg-magenta1-light': sortBy=='f.PriorityId'}" class="dropdown-item" @click.prevent="sortList('f.PriorityId')">{{lableText('PriorityId')??'اولویت'}}</a>
                                </div>
                            </div>
                        </div>

                        <div class="w-100 search-box search-color bg-magenta1-light rounded-m position-relative">
                            <i class="fa fa-search pr-3"></i>
                            <input type="text" class="border-0" placeholder="جستجو..." data-search="" v-model="searchKey" @change="refreshTaskList">
                        </div>
                    </div>

                    <div class="checkboxRow px-3 pb-3">
                        <div class="fac fac-checkbox fac-green">
                            <span></span>
                            <input id="box6-fac-checkbox" @change="ChangeShowOnlyMyTask" type="checkbox" v-model="showOnlyMyTask">
                            <label for="box6-fac-checkbox" class="font-weight-bold">فقط {{lableText('TasksName')??'وظایف'}} مربوط به من</label>
                        </div>
                    </div>
                </div>
                <calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>


                <!--<div class="bg-white">
                <ul class="nav nav-pills filterTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="pill" href="#status01">باز</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="pill" href="#status02">بسته شده</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="pill" href="#status03">بسته شده به موقع</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="pill" href="#status04">ناتمام</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="pill" href="#status05">سررسید گذشته</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="pill" href="#status06">بسته شده با تأخیر</a>
                    </li>
                </ul>-->
                <!-- Tab panes -->
                <!--<div class="tab-content">
                        <div id="status01" class="container tab-pane active">
                            <div>وظایف باز</div>
                        </div>
                        <div id="status02" class="container tab-pane fade">
                            <div>وظایف بسته شده</div>
                        </div>
                        <div id="status03" class="container tab-pane fade">
                            <div>وظایف بسته شده به موقع</div>
                        </div>
                        <div id="status04" class="container tab-pane fade">
                            <div>وظایف ناتمام</div>
                        </div>
                        <div id="status05" class="container tab-pane fade">
                            <div>وظایف سررسید گذشته</div>
                        </div>
                        <div id="status06" class="container tab-pane fade">
                            <div>وظایف بسته شده با تأخیر</div>
                        </div>
                    </div>
                </div>-->

                <div class="card card-style mb-2" v-for="task in TaskDetailList" :key="task.taskFolderId" :id="'taskBox-'+task.taskFolderId" :class="getClassNameForTaskBorder(task.taskFolderId,task.viewTaskStatusId)">
                    <div class="py-2 pl-2">
                        <button data-toggle="collapse" type="button" :data-target="'#collapse-'+task.taskFolderId" class="no-effect collapsed accordion-btn pr-0" aria-expanded="false">
                            <span class="d-flex justify-content-between align-items-center">
                                <span class="d-flex flex-column px-2 w-100 d-flex">
                                    <b class="font-15 text-dark">{{task.taskTitle}}</b>
                                    <span class="taskStartEndDateTime-box text-muted d-flex justify-content-between">
                                        <span>
                                            شروع: <span class="d-inline-block ltr">{{task.startDateTime}}</span>
                                        </span>
                                        <span>
                                            پایان: <span class="d-inline-block ltr">{{task.endDateTime}}</span>
                                        </span>
                                    </span>
                                </span>
                                <i class="fa fa-angle-up text-muted font-18 accordion-icon fa-rotate-180"></i>
                            </span>
                        </button>
                    </div>
                    <div class="collapse border-t" :id="'collapse-'+task.taskFolderId" @click.prevent="openDetails(task.taskFolderId,task.taskId)">
                        <div class="d-flex justify-content-between m-0 pt-3 pr-4 pl-3">
                            <div class="col p-0 text-right">
                                <i class="fa fa-hashtag color-blue2-dark ml-3"></i>
                                <span class="text-muted">{{task.taskNo}}</span>
                            </div>
                            <div v-if="task.rateValue!=null" class="col p-0 d-flex justify-content-center">
                                <star-rating v-model="task.rateValue" :show-rating="false" :read-only="readOnly" :rounded-corners="true" :star-size="15" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"></star-rating>
                            </div>
                            <div class="col p-0 text-left">
                                <span class="badge font-10 position-static mt-0" :id="'taskStatusSpan-'+task.taskFolderId" :class="getClassNameForTaskSpan(task.taskFolderId,task.viewTaskStatusId)">{{task.viewTaskStatusTitle}}</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between py-3 pr-4 pl-3">
                            <div class="d-flex justify-content-between" style="width:90%">
                                <div v-if="task.userTitle!=task.receiverUserTitle">
                                    <i class="fa fa-user color-green2-light ml-2 position-relative">
                                        <i class="fa fa-level-up-alt color-green2-light" style="position:absolute;right:-8px;top:-7px"></i>
                                    </i>
                                    <span class="font-weight-bold">{{task.userTitle}}</span>
                                </div>
                                <div>
                                    <i class="fa fa-user color-magenta2-dark ml-2 position-relative">
                                        <i class="fa fa-level-down-alt color-magenta2-dark" style="position:absolute;right:-7px;top:-7px"></i>
                                    </i>
                                    <span class="font-weight-bold">{{task.receiverUserTitle}}</span>
                                </div>
                                <div v-if="task.stepTitle!=null">
                                    <i class="fa fa-chart-line color-red1-dark ml-3"></i>
                                    <span class="font-weight-bold">{{task.stepTitle}}</span>
                                </div>
                            </div>
                            <span class="text-left" style="width:10%" @click.stop="showMenu(task)"><i class="fa fa-ellipsis-v ml-0 font-14"></i></span>
                        </div>
                    </div>
                </div>


                <div class="card card-style" v-if="Loading==false && NoMoreData==false && TaskDetailList.length>0">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <button class="btn btn-outline-info" @click="getNextPageForTaskList">نمایش بیشتر</button>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="TaskDetailList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">{{lableText('TaskName')??'وظیفه'}} ای یافت نشد.</p>
                    </div>
                </div>
            </div>

            <div class="card card-style" v-else>
                <div class="content">
                    <h4 class="mb-0 text-center">تصاویر بخش لیست {{lableText('TasksName')??'وظایف'}} </h4>
                </div>
                <div class="divider mb-0"></div>
                <div class="gallery-view-controls d-flex justify-content-center">
                    <a href="#" class="gallery-view-1-activate"><i class="fa fa-th"></i></a>
                    <a href="#" class="gallery-view-2-activate color-highlight"><i class="fa fa-th-large"></i></a>
                    <div class="clearfix"></div>
                </div>
                <div class="content my-n1">
                    <div class="gallery-views gallery-view-2">
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/taskList-L.jpg" :title="lableText('TasksName')??'وظایف' + 'من'" class="default-link">
                            <img src="/assets/images/gallery/taskList-500x500.jpg" data-src="/assets/images/gallery/taskList-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">{{lableText('TasksName')??'وظایف'}} من</h4>
                                <!--<p>Some may consider this to be a very messy desk.</p>-->
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/taskList-2-L.jpg" title="عملیات مربوط به هر وظیفه" class="default-link">
                            <img src="/assets/images/gallery/taskList-2-500x500.jpg" data-src="/assets/images/gallery/taskList-2-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">عملیات مربوط به هر {{lableText('TaskName')??'وظیفه'}}</h4>
                                <!--<p>With all the gadgets you'd ever wish for.</p>-->
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/taskList-3-L.jpg" title="ثبت وظیفه" class="default-link">
                            <img src="/assets/images/gallery/taskList-3-500x500.jpg" data-src="/assets/images/gallery/taskList-3-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">ثبت {{lableText('TaskName')??'وظیفه'}}</h4>
                                <!--<p>The perfect and small notification device.</p>-->
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/taskList-4-L.jpg" title="سیر زمانی انجام هر وظیفه" class="default-link">
                            <img src="/assets/images/gallery/taskList-4-500x500.jpg" data-src="/assets/images/gallery/taskList-4-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">سیر زمانی انجام هر {{lableText('TaskName')??'وظیفه'}}</h4>
                                <!--<p>It's absolutely gorgeous, we'd love to see it live.</p>-->
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/taskList-5-L.jpg" title="جزییات وظیفه" class="default-link">
                            <img src="/assets/images/gallery/taskList-5-500x500.jpg" data-src="/assets/images/gallery/taskList-5-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">جزییات {{lableText('TaskName')??'وظیفه'}}</h4>
                                <!--<p>A beautifully captured snap with great contrast.</p>-->
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/taskList-6-L.jpg" title="جستجوی پیشرفته وظایف" class="default-link">
                            <img src="/assets/images/gallery/taskList-6-500x500.jpg" data-src="/assets/images/gallery/taskList-6-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class=" color-theme">جستجوی پیشرفته {{lableText('TasksName')??'وظایف'}}</h4>
                                <!--<p>Going back to days when things were simplere.</p>-->
                            </div>
                        </a>
                    </div>
                </div>

                <a href="/order" class="btn btn-l btn-icon bg-green2-dark rounded-s shadow-s btn-full btn-margins font-900 text-uppercase text-left mt-3"><i class="fa fa-credit-card text-center"></i>تهیه اشتراک اپلیکشن</a>
            </div>
        </div>

        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-if="pageLoaded==true && isFreeRegist!==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
                <router-link to="/CreateTask" class="btn px-3 py-2 rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link class="d-flex justify-content-between align-items-center" :to="{ name: 'EditTask', params: { taskFolderId: selectedTaskFolderId,taskId:selectedTaskId  } }">
                        <span><i class="fa fa-search color-green2-light float-right font-14"></i>جزئیات</span>
                        <i class="fa fa-angle-left"></i>
                    </router-link>
                    <button class="d-flex justify-content-between align-items-center bg-white p-0" @click.prevent="CloseTaskFolder"><span class="d-inline-flex align-items-center"><i class="fa fa-times color-red1-light float-right font-14"></i>درخواست بستن</span><i class="fa fa-angle-left"></i></button>
                    <button class="d-flex justify-content-between align-items-center bg-white p-0" @click.prevent="CanAddTaskWork"><span class="d-inline-flex align-items-center"><i class="fa fa-check-square color-blue2-light float-right font-14"></i>ثبت پیگیری</span><i class="fa fa-angle-left"></i></button>
                    <router-link class="d-flex justify-content-between align-items-center" :to="{ name: 'CreateReminder', params: { taskId: selectedTaskId} }">
                        <span><i class="fa fa-bell color-green2-light float-right font-14"></i>تکرار دوره ای</span>
                        <i class="fa fa-angle-left"></i>
                    </router-link>
                    <button class="d-flex justify-content-between align-items-center bg-white p-0" @click.prevent="onShowRateClick"><span class="d-inline-flex align-items-center"><i class="fa fa-star color-yellow1-light float-right font-14"></i>امتیازدهی</span><i class="fa fa-angle-left"></i></button>
                    <button class="d-flex justify-content-between align-items-center bg-white p-0" @click.prevent="onShowRefClick"><span class="d-inline-flex align-items-center"><i class="fa fa-info color-yellow1-light float-right font-14"></i>ثبت شناسه</span><i class="fa fa-angle-left"></i></button>
                    <button @click="AddPin" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-thumbtack color-blue2-light float-right font-14"></i>نشان کردن</span><i class="fa fa-angle-left"></i></button>
                    <button @click="returnFromCloseTaskFolder" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-undo color-yellow1-light float-right font-14"></i>باز کردن {{lableText('TaskName')??'وظیفه'}} بسته شده</span><i class="fa fa-angle-left"></i></button>


                    <button @click="deleteTask" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div id="searchModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <div class="modal-content">

                    <div class="modal-header align-items-center">
                        <h4 class="modal-title">جستجوی پیشرفته</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body m-0">
                        <div class="search-box bg-magenta1-light rounded-m mb-3">
                            <i class="fa fa-search"></i>
                            <input type="text" class="border-0" placeholder="جستجو..." data-search="" v-model="searchKey">
                        </div>
                        <div class="mb-3">
                            <v-select dir="rtl" label="title" placeholder="وضعیت" :filterable="false" :searchable="false" multiple chips :options="statusList" :reduce="p => p.type" v-model="statusIds">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>

                        </div>

                        <div class="mb-3">
                            <v-select dir="rtl" label="title" placeholder="ارجاع گیرنده" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId" v-model="parentUserId">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <!--<div>
                            <div class="fac fac-checkbox fac-orange">
                                <span></span>
                                <input id="box5-fac-checkbox" type="checkbox" v-model="teamTask">
                                <label for="box5-fac-checkbox">نمایش وظایف تیم من</label>
                            </div>
                        </div>-->
                        <br />
                        <div>
                            <div class="fac fac-checkbox fac-green">
                                <span></span>
                                <input id="box6-fac-checkbox" type="checkbox" v-model="searchInDesc">
                                <label for="box6-fac-checkbox">جستجو در توضیحات وظیفه</label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900" data-dismiss="modal" @click="refreshTaskList">
                            <i class="fa fa-search ml-2"></i>
                            جستجو
                        </button>
                    </div>

                </div>

            </div>

        </div>
        <ion-modal :is-open="showCreateTaskModal" :can-dismiss="canDismiss" @didDismiss="openModal(false)" :breakpoints="[0, 0.5, 1]" :initialBreakpoint="0.5">
            <ion-content>
                <button @click="moveTo(1)">move up</button>
                <task-create></task-create>
            </ion-content>
        </ion-modal>


        <Help-Menu :title="pageTitle" keyEn="TaskList"></Help-Menu>
        <my-tour></my-tour>
    </div>



</template>

<script>

    import 'vue-select/dist/vue-select.css';
    import taskrate from './TaskRate.vue'
    import myTour from '../Tours/TaskListTour.vue'
    import taskref from './TaskReference.vue'
    import taskCloseConfirm from './TaskCloseCofirm.vue'
    import calendarFilter from '../Components/CalendarFilter.vue';
    import StarRating from 'vue-star-rating'
    import VueSimpleAlert from 'vue3-simple-alert';
    import taskCreate from './CreateTask.vue';
    import HelpMenu from '../Components/HelpMenu.vue';
    import { IonModal, IonContent } from '@ionic/vue';

    export default {

        components: {
            "task-rate-modal": taskrate,
            "Help-Menu": HelpMenu,
            "task-reference": taskref,
            "task-close-confirm": taskCloseConfirm,
            "calendar-filter": calendarFilter,
            myTour,
            StarRating,

            IonModal,
            IonContent,
            taskCreate,
        },

        setup() {
            const canDismiss = async () => {
                this.showCreateTaskModal = false;
                return true;
            };

            return { canDismiss };
        },
        data() {
            return {
                pageTitle: "",
                page: 1,
                selectedTaskFolderId: 0,
                selectedTaskId: 0,
                selectedTaskProgress: 0,
                selectedTaskTitle: 0,
                pageLoaded: false,
                sortBy: "f.CreateDateTime",
                sortByDesc: true,
                searchKey: null,
                searchInDesc: false,
                showOnlyMyTask: false,
                searchInProps: false,
                parentUserId: null,
                date: null,
                statusIds: ["2,3"],
                teamTask: true,
                statusList: [
                    { title: "باز", type: "2,3" },
                    { title: "بسته شده", type: "1,4" },
                    { title: "بسته شده به موقع", type: "1" },
                    { title: "ناتمام", type: "2" },
                    { title: "سررسيد گذشته", type: "3" },
                    { title: "بسته شده با تاخير", type: "4" },
                ],
                showTaskrateModal: false,
                showTaskRefModal: false,
                showTaskCloseModal: false,
                showCreateTaskModal: false,
            };
        },


        //watch: {
        //    'showOnlyMyTask'(value) {
        //        this.$http
        //            .get(
        //                "Task/SetShowOnlyMyTask?showOnlyMyTask=" + value)
        //            .then((data) => {
        //                var res = data.data;
        //                if (res.isSuccess) {
        //                    setTimeout(function () {
        //                        window.location.reload();
        //                    }, 100);
        //                }
        //                else {
        //                    this.showErrorMessage(res.message);
        //                }
        //            });

        //    },
        //},
        computed: {
            TaskDetailList() {
                return this.$store.getters.GetTaskDetailList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            isFreeRegist() {
                return this.$store.getters.GetIsFreeRegist;
            },
            UpdateTaskList() {
                return this.$store.getters.GetUpdateTaskList;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
            NoMoreData() {
                return this.$store.getters.GetTaskListNoMoreData;
            },
            orderBy() {
                if (this.sortByDesc == true) {
                    return this.sortBy + " desc";
                } else {
                    return this.sortBy;
                }
            },

        },

        created() {
            console.log("create");
            this.getUserList();
            this.$http
                .get(
                    "Task/GetDocCacheForUser")
                .then((data) => {
                    var res = data.data;
                    if (res.isSuccess) {
                        if (res.obj.cacheJson == "1") {
                            this.showOnlyMyTask = true;
                        } else {
                            this.showOnlyMyTask = false;
                        }
                    }
                    this.GetTaskList();
                });

            this.pageTitle = "راهنمای ثبت " + (this.lableText('TaskName') ?? 'وظیفه');
        },
        methods: {
            ChangeShowOnlyMyTask() {
                this.$http
                    .get(
                        "Task/SetShowOnlyMyTask?showOnlyMyTask=" + this.showOnlyMyTask)
                    .then((data) => {
                        var res = data.data;
                        if (res.isSuccess) {
                            setTimeout(function () {
                                window.location.reload();
                            }, 100);
                        }
                        else {
                            this.showErrorMessage(res.message);
                        }
                    });
            },
            selectDate(d) {
                this.date = d;
                this.page = 1;
                this.GetTaskList();
            },
            moveTo(point) {

                this.modalController.setCurrentBreakpoint(point);
            },
            async openModal(val) {
                this.showCreateTaskModal = val;
            },
            getUserList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    workGroupId: null
                });
            },
            refreshTaskList() {
                this.page = 1;
                this.GetTaskList();
            },
            GetTaskList() {
                this.$store.dispatch("GetTaskDetailListFromServer", {
                    pageId: this.page,
                    searchKey: this.searchKey,
                    orderBy: this.orderBy,
                    showOnlyMyTask: this.showOnlyMyTask,
                    statusIds: this.statusIds.join(),
                    parentUserId: this.parentUserId,
                    userTeamTask: this.teamTask,
                    date: this.date,
                    searchInDesc: this.searchInDesc,
                    searchInOtherProps: this.searchInProps,
                });
            },
            showAddButton() {
                this.pageLoaded = true;

            },
            showMenu(t) {
                this.selectedTaskFolderId = t.taskFolderId;
                this.selectedTaskId = t.taskId;
                this.selectedTaskProgress = t.progressRate;
                this.selectedTaskTitle = t.taskTitle;
                document.getElementsByClassName("optionMenu")[0].click();
                console.log(this.selectedTaskProgress);
            },
            CloseTaskFolder() {
                document.getElementsByClassName("menu-hider")[0].click();

                VueSimpleAlert.confirm(
                    "آیا مایل به بستن این " + (this.lableText('TaskName') ?? 'وظیفه') + " هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    this.$http
                        .get(
                            "TaskWork/GetTaskWorkStatusForClose?taskId=" +
                            this.selectedTaskId +
                            "&taskFolderId=" +
                            this.selectedTaskFolderId
                        )
                        .then((data) => {
                            var res = data.data;
                            if (res.resultCode == "1") {
                                this.sendCloseTaskFolder();
                            } else if (res.resultCode == "0") {
                                this.showErrorMessage(res.result);
                            } else if (res.resultCode == "2") {
                                this.showTaskCloseModal = true;
                                document.getElementsByClassName("menu-hider")[0].click();
                            }
                        });
                });
            },
            sendCloseTaskFolder() {
                this.showTaskCloseModal = false;
                this.$http
                    .get("TaskCloseRequest/CloseTaskFolder", {
                        params: {
                            taskFolderId: this.selectedTaskFolderId,
                        },
                    })
                    .then((data) => {
                        if (data.data == "1") {
                            this.showSuccessMessage("درخواست بستن با موفقیت ثبت شد.");
                            this.page = 1;
                            this.GetTaskList();
                        } else {
                            this.showMessage(data.data);
                        }
                    });
            },
            returnFromCloseTaskFolder() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به باز کردن مجدد این آیتم هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {

                    this.$http
                        .get("TaskCloseRequest/ReturnFromClose", {
                            params: {
                                taskFolderId: this.selectedTaskFolderId,
                            },
                        })
                        .then((data) => {
                            if (data.data == "1") {
                                this.showSuccessMessage("بازگشت از بستن با موفقیت انجام شد.");
                                this.page = 1;
                                this.GetTaskList();
                            } else {
                                this.showMessage(data.data);
                            }
                        });
                });





            },
            CanAddTaskWork() {
                this.$http
                    .get(
                        "TaskWork/CanAddTaskWork?taskId=" +
                        this.selectedTaskId +
                        "&taskFolderId=" +
                        this.selectedTaskFolderId
                    )
                    .then((data) => {
                        var res = data.data;
                        if (res != "1") {
                            this.showMessage(res);
                        } else {
                            this.$router.push({
                                name: "CreateTaskWork",
                                query: {
                                    taskfolderId: this.selectedTaskFolderId,
                                    taskId: this.selectedTaskId,
                                },
                            });
                        }
                    });
            },

            goToTaskWorkList() {
                this.$store.dispatch("ClearTaskWorkList");
                this.$router.push({
                    name: "TaskWorkList",
                    params: {
                        taskFolderId: this.selectedTaskFolderId,
                        taskId: this.selectedTaskId,
                    },
                });
            },
            getNextPageForTaskList() {
                this.page++;
                console.log(this.page);
                this.GetTaskList();
            },
            sortList(name) {
                this.sortBy = name;
                this.refreshTaskList();
                document.getElementById("dropdownMenuSortDiv").classList.remove("show");

                //
            },
            onShowRateClick() {
                this.showTaskrateModal = true;
                document.getElementsByClassName("menu-hider")[0].click();
            },
            onShowRefClick() {
                document.getElementsByClassName("menu-hider")[0].click();
                this.showTaskRefModal = true;
            },
            openDetails(taskFolderId, taskId) {
                this.$router.push({
                    name: "EditTask",
                    params: { taskFolderId: taskFolderId, taskId: taskId },
                });
                document.getElementsByClassName("menu-hider")[0].click();
            },
            pauseVid(id) {
                if (id != null) {
                    var vid = document.getElementById(id);
                    vid.pause();
                }

            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
            deleteTask() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به حذف این " + (this.lableText('TaskName') ?? 'وظیفه') + " هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    this.$http
                        .get("Task/DeleteTask?id=" + this.selectedTaskId)
                        .then((data) => {
                            var res = data.data;
                            if (res == "1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                document.getElementsByClassName("menu-hider")[0].click();
                                this.page = 1;
                                this.GetTaskList();
                            } else {
                                this.showErrorMessage(res);
                            }
                        });
                });
            },
            getClassNameForTaskSpan(folderId, statusTitle) {
                var classNsme = "";
                statusTitle = parseInt(statusTitle);

                switch (statusTitle) {
                    case 2:
                        classNsme = "badge-primary";
                        break;
                    case 3:
                        classNsme = "badge-danger";
                        break;
                    case 4:
                        classNsme = "badge-warning text-white";
                        break;
                    case 1:
                        classNsme = "badge-success";
                        break;
                    default:
                        classNsme = "badge-info";
                        break;
                }
                return classNsme;
            },

            getClassNameForTaskBorder(folderId, statusTitle) {
                var classNsme = "";
                statusTitle = parseInt(statusTitle);

                switch (statusTitle) {
                    case 2:
                        classNsme = "border-r-primary";
                        break;
                    case 3:
                        classNsme = "border-r-danger";
                        break;
                    case 4:
                        classNsme = "border-r-warning";
                        break;
                    case 1:
                        classNsme = "border-r-success";
                        break;
                    default:
                        classNsme = "border-r-info";
                        break;
                }
                return classNsme;
            },
            AddPin() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به نشان کردن این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {

                    this.$store.dispatch("AddPin", {
                        baseDocId: 26,
                        docId: this.selectedTaskId,
                        description: this.selectedTaskTitle
                    });
                });

            },
        },
        mounted() {
            this.showAddButton();
            document
                .querySelectorAll(".menu-box-right")
                .forEach((a) => (a.style.display = "block"));
        },
        activated() {
            this.showAddButton();
            if (this.UpdateTaskList == true) {
                this.page = 1;
                this.GetTaskList();
            }

        },
    };
</script>
